var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _path30, _path31, _path32, _path33, _polygon10, _polygon11, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabRuby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Facets",
    viewBox: "0 0 14.98 14.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n            fill: #7d7d7d;\n            }\n\n            .cls-2 {\n            fill: #75081f;\n            }\n\n            .cls-3 {\n            fill: #990b29;\n            }\n\n            .cls-4 {\n            fill: #9f9f9f;\n            }\n\n            .cls-5 {\n            fill: #870a25;\n            }\n\n            .cls-6 {\n            fill: #a30c2c;\n            }\n\n            .cls-7 {\n            fill: #910b27;\n            }\n\n            .cls-8 {\n            fill: #8e0a26;\n            }\n\n            .cls-9 {\n            fill: #b0b0b0;\n            }\n\n            .cls-10 {\n            fill: #c10e34;\n            }\n\n            .cls-11 {\n            fill: #230309;\n            }\n\n            .cls-12 {\n            fill: #430512;\n            }\n\n            .cls-13 {\n            fill: #1b0207;\n            }\n\n            .cls-14 {\n            fill: #717171;\n            }\n\n            .cls-15 {\n            fill: #6e6e6e;\n            }\n\n            .cls-16 {\n            fill: #560617;\n            }\n\n            .cls-17 {\n            fill: #5c0719;\n            }\n\n            .cls-18 {\n            fill: #5a0718;\n            }\n\n            .cls-19 {\n            fill: #490514;\n            }\n\n            .cls-20 {\n            fill: #580618;\n            }\n\n            .cls-21 {\n            fill: #5f0719;\n            }\n\n            .cls-22 {\n            fill: #780920;\n            }\n\n            .cls-23 {\n            fill: #530616;\n            }\n\n            .cls-24 {\n            fill: #850a24;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1.07,11.45c-.09-.14-.17-.29-.25-.43.08.15.16.29.25.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m2.61,13.27c-.22-.19-.43-.39-.62-.6.2.21.4.41.62.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1.8,12.46c-.17-.2-.33-.4-.48-.62.15.21.31.42.48.62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m6.35,14.98c-.25-.04-.5-.09-.74-.15.24.06.49.11.74.15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m8.6.18c.25.04.5.09.74.15-.24-.06-.49-.11-.74-.15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m.6,10.56c-.05-.11-.08-.21-.13-.32.04.11.08.22.13.32Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m12.51,2.04c.1.09.21.19.31.29-.1-.1-.2-.19-.31-.29Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m7.49.08c.3,0,.6.02.89.06-.29-.04-.59-.06-.89-.06Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m.03,8.38c0-.06,0-.12-.01-.17,0,.06,0,.12.01.17Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m.18,9.26c-.02-.08-.04-.16-.05-.24.02.08.04.16.05.24Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m10.43.7h0c-.31-.13-.63-.24-.95-.33.32.09.62.2.92.32,0,0,.02,0,.03,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m4.47,14.44h0c-.08-.04-.16-.09-.24-.13-.16-.08-.32-.16-.48-.25-.07-.04-.14-.07-.21-.11.59.37,1.24.65,1.92.84-.34-.09-.67-.22-.99-.36h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m3.22,13.72c-.19-.13-.39-.26-.56-.41.26.22.54.42.84.6-.08-.05-.16-.12-.24-.17-.01,0-.02-.02-.04-.03Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m10.57.76c.64.29,1.23.66,1.76,1.11-.56-.48-1.2-.88-1.88-1.18h0s.08.05.12.07Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m13.22,2.77s.03.03.04.04c-.01-.01-.03-.03-.04-.04Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m4.23,14.31c.08.04.16.09.24.13h0c-.08-.04-.16-.09-.23-.13Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m.63,10.53l-.04-.03v-.04C.23,9.57,0,8.61,0,7.58s.22-2.05.61-2.95h0s0,0,0,0c.77-1.78,2.2-3.2,3.99-3.95h0s0,0,0,0c.89-.37,1.87-.58,2.89-.58.67,0,1.32.09,1.94.25-.03,0-.06-.01-.09-.02-.24-.06-.49-.11-.74-.15-.07-.01-.15-.02-.22-.03-.29-.04-.59-.06-.89-.06-.01,0-.02,0-.04,0C3.32.08-.03,3.43-.03,7.57c0,.22.03.43.05.64,0,.06,0,.12.01.17.02.22.06.43.1.64.02.08.04.16.05.24.08.34.18.66.3.98.04.11.08.22.13.32.07.16.14.31.22.46.08.15.16.29.25.43.08.13.16.26.25.39.15.21.31.42.48.62.06.07.13.14.19.21.2.21.4.41.62.6.01.01.03.03.04.04.18.15.37.28.56.41-1.13-.8-2.03-1.9-2.58-3.19Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m3.25,13.74c.08.06.15.12.24.17.02.01.03.02.05.03.07.04.14.07.21.11-.17-.1-.34-.2-.5-.31Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m4.49,14.43h-.01c.32.14.65.26.99.36.02,0,.03.01.05.02-.36-.1-.7-.23-1.03-.38Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m14.37,4.69l.05.03c-.29-.7-.68-1.34-1.16-1.91-.01-.01-.03-.03-.04-.04-.13-.15-.27-.31-.41-.45-.1-.1-.2-.19-.31-.29-.06-.05-.12-.11-.18-.16-.53-.45-1.12-.82-1.76-1.11,1.71.78,3.07,2.19,3.8,3.93Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.46,14.43c-.92.4-1.94.63-3,.63-.67,0-1.32-.09-1.94-.25.03,0,.06.01.09.02.24.06.49.11.74.15.07.01.15.02.22.03.29.04.59.06.89.06.01,0,.03,0,.04,0,1.07,0,2.09-.23,3.01-.63h-.05Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m3.45,5.89l-.49-2.79,1.64-2.43c-1.79.75-3.22,2.17-3.99,3.95l2.34-1.52.5,2.79Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m.61,4.63C.22,5.54,0,6.53,0,7.58s.23,1.99.6,2.88l.53-2.79-.52-3.04Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m7.46,15.06c1.07,0,2.08-.22,3-.63l-3.1-.42-2.87.41c.33.15.67.28,1.03.38.62.17,1.27.25,1.94.25Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m2.97,12.12l-2.34-1.59c.56,1.29,1.45,2.39,2.58,3.19.01,0,.02.02.04.03.16.11.33.21.5.31.16.09.32.17.48.25.08.04.15.08.23.12l-1.49-2.31Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m14.37,4.69c-.73-1.74-2.09-3.14-3.8-3.93-.04-.02-.08-.04-.12-.06l1.67,2.41,2.25,1.57Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m7.49.09c-1.02,0-2,.21-2.89.58l2.89.48,2.94-.45s-.02,0-.03,0c-.3-.13-.6-.23-.92-.32-.02,0-.04-.01-.05-.02-.62-.17-1.27-.25-1.94-.25Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m14.42,4.72v.06c.33.86.52,1.8.52,2.79s-.21,2.01-.58,2.9v.07c.4-.91.62-1.91.62-2.96s-.2-1.98-.56-2.86Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m14.36,10.47c.37-.89.58-1.87.58-2.9s-.19-1.93-.54-2.79l-.54,2.95.49,2.73Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m14.32,10.58c-.74,1.69-2.1,3.06-3.78,3.82l-.03.04c1.73-.76,3.12-2.16,3.87-3.9l-.06.04Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m10.53,14.4c1.69-.76,3.04-2.13,3.78-3.82l-2.24,1.42-1.54,2.41Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "5.87 3.46 3.45 5.89 3.42 9.3 5.79 11.67 9.16 11.71 11.53 9.26 11.57 5.9 9.3 3.45 5.87 3.46"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "9.3 3.45 7.49 1.15 5.87 3.46 9.3 3.45"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "2.97 12.12 5.79 11.67 3.42 9.3 2.97 12.12"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "5.79 11.67 7.36 14.02 9.16 11.71 5.79 11.67"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "13.87 7.74 11.57 5.9 11.53 9.26 13.87 7.74"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "12.07 12 11.53 9.26 9.16 11.71 12.07 12"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "1.13 7.67 3.42 9.3 3.45 5.89 1.13 7.67"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2.96 3.11 3.45 5.89 5.87 3.46 2.96 3.11"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.57 5.9 12.12 3.12 9.3 3.45 11.57 5.9"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "3.45 5.89 2.95 3.11 .61 4.63 .61 4.63 .61 4.63 1.13 7.67 3.45 5.89"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "5.87 3.46 7.49 1.15 4.6 .67 4.6 .67 4.6 .67 2.96 3.11 5.87 3.46"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m14.37,4.69s.03.06.04.09v-.06s.01,0,.01,0l-.05-.03Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m12.12,3.12l-.55,2.78,2.3,1.84.54-2.95s-.03-.06-.04-.09l-2.25-1.57Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.45.7h0s0,0,0,0h0s0,0,0,0c0,0,.01,0,.02,0Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m12.12,3.12l-1.67-2.41s-.01,0-.02,0l-2.94.45,1.81,2.3,2.81-.33Z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "3.42 9.3 1.13 7.67 .6 10.46 .6 10.51 .63 10.53 2.97 12.12 3.42 9.3"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "2.97 12.12 4.46 14.42 4.47 14.43 4.47 14.44 4.47 14.43 4.49 14.43 7.36 14.02 5.79 11.67 2.97 12.12"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m14.36,10.47s-.03.07-.05.11l.06-.04h0s-.01-.07-.01-.07Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m11.53,9.26l.54,2.73,2.24-1.42s.03-.07.05-.11l-.49-2.73-2.34,1.52Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m10.53,14.4s-.05.02-.07.03h.05s.03-.03.03-.03Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m9.16,11.71l-1.8,2.31,3.1.42s.05-.02.07-.03l1.54-2.41-2.91-.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabRuby);
export default __webpack_public_path__ + "static/media/LabRuby.cfde923520d767f7d1a574b272a71f1a.svg";
export { ForwardRef as ReactComponent };